import { useMemo } from 'react';

import { useLabelsStore } from '../../store';
import type { HierarchicalLabelOrFolder } from '../../store/Inbox/Labels/types';
import { getItemId } from '../../utils/getItemIdForLabelsAndFolders';

function findInTree(
  id: string,
  nodes: HierarchicalLabelOrFolder[],
): HierarchicalLabelOrFolder | undefined {
  for (const node of nodes) {
    if (getItemId(node) === id) {
      return node;
    }

    if (node.children && node.children.length > 0) {
      const found = findInTree(
        id,
        node.children as HierarchicalLabelOrFolder[],
      );
      if (found) {
        return found;
      }
    }
  }

  return undefined;
}

export function useLabelNameById(
  labelId: string | undefined,
): string | undefined {
  const { labels } = useLabelsStore();

  return useMemo(() => {
    if (!labelId) {
      return undefined;
    }

    const match = findInTree(labelId, labels);
    return match && 'displayName' in match ? match.displayName : undefined;
  }, [labelId, labels]);
}
